module.exports = __webpack_public_path__ + "img/6.de84c9dd.png";